export enum APP_TYPE {
  ZONO_MONEY = 'ZONO_MONEY',
  SELLER_HUB = 'SELLER_HUB',
  FIELDS_OPS = 'FIELD_OPS',
}
